import { render } from "./HeroiconsSolidInformationCircle.vue?vue&type=template&id=06768b9a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidInformationCircle.vue"]])

export default __exports__